import Dexie, { Table } from 'dexie';

export interface serverItem {
  id?: number;
  url: string;
  serverStr: string;
}

export class GameBoxDexie extends Dexie {
  // 'server' is added by dexie when declaring the stores()
  // We just tell the typing system this is the case
  serverList!: Table<serverItem>;

  constructor() {
    super('gameboxbase');
    this.version(1).stores({
      serverList: '++id, url, serverStr' // Primary key and indexed props
    });
  }
}

export const db = new GameBoxDexie();
